module.exports = __webpack_public_path__ + "img/c5201909-1.5db9e221.jpg";